module.exports = __webpack_public_path__ + "img/client-11.89207b08.png";